import React, { Component } from 'react';

import styles from './GenericText.scss';
import PrivacyPolicyText from './strings/PrivacyPolicyText';
import TeachersLandingText from './strings/TeachersLanding';
import AboutText from './strings/About';
import TermsOfUseText from './strings/TermsOfUse';
import PageNotFoundText from './strings/PageNotFound';
import UnknownErrorText from './strings/UnknownError';
import ForbiddenText from './strings/Forbidden';
import AdvertiseText from './strings/AdvertiseText';

class GenericText extends Component {
  constructor(props) {
    super(props);

    this.mapIdToString = {
      about: <AboutText />,
      teachersLanding: <TeachersLandingText />,
      privacy: <PrivacyPolicyText />,
      terms: <TermsOfUseText />,
      pageNotFound: <PageNotFoundText />,
      forbidden: <ForbiddenText />,
      'advertise-with-us': <AdvertiseText />,
      unknownError: <UnknownErrorText />,
    };
  }

  render() {
    const { contentId, extraClass } = this.props;
    if (this.mapIdToString[contentId]) {
      return (
        <div className={`GenericText${extraClass}`}>
          {this.mapIdToString[contentId]}
        </div>
      );
    } else {
      return null;
    }
  }
}

GenericText.defaultProps = {
  extraClass: '',
};

export default GenericText;
